import styled from 'styled-components';

const StyledHomeColumns = styled.div`
position: relative;
padding: ${props => props.theme.components_spacing_desk.xlarge}px 64px;
display: flex;
align-items: flex-start;
.home--col{
  position: relative;
  width: 24.99%;
  margin-right: 8.33%;
}
.grey{
  color: #666666;
}
.col-separator{
  position: relative;
  width: 100%;
  height: 1px;
  background-color: #B3B3B3;
  margin: 24px 0;
}
.col-separator::before{
  content: '';
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${props => props.theme.colors.green_secondary};
  
}
@media screen and (max-width: 1439px){
  padding: ${props => props.theme.components_spacing_desk.xlarge}px 40px;
}
@media screen and (max-width: 1023px){
  padding: ${props => props.theme.components_spacing_tablet.xlarge}px 40px;

}
@media screen and (max-width: 767px){
  padding: ${props => props.theme.components_spacing_mobile.xlarge}px 24px;
  flex-direction: column;
  .home--col{
    width: 100%;
    margin: 0 auto 40px;
    &:nth-child(3){
      margin-bottom: 0;
    }
  }
  
  
}

`;

export {
  StyledHomeColumns,
};

